import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../style.css';

function PlacementTest() {
  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Spanish Placement Test | Culturlingua</title>
        <meta name="description" content="Take our free Spanish placement test and find out your current level. Quick and easy online test." />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Free · 10 minutes</div>
        <h1>Spanish Placement Test</h1>
        <p>Take your time to answer the exam and correctly assess your level of Spanish.</p>
      </div>

      <section style={{background:'var(--cream)', padding:'60px 48px'}}>
        <div style={{maxWidth:'900px', margin:'0 auto'}}>
          <div style={{display:'flex', gap:'12px', flexWrap:'wrap', justifyContent:'center', marginBottom:'40px'}}>
            {['⏱️ 10 minutes','🆓 Free','📱 Any device','🏆 Instant result'].map(p => (
              <span key={p} style={{background:'white', border:'1px solid #e5e7eb', padding:'8px 18px', borderRadius:'100px', fontSize:'0.875rem', color:'var(--text)', fontWeight:'500'}}>
                {p}
              </span>
            ))}
          </div>

          <div style={{background:'white', borderRadius:'20px', overflow:'hidden', boxShadow:'0 4px 24px rgba(0,0,0,0.08)'}}>
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLScpQwp66A8BVIUGB4e0PZ8N_ogjYNcbKVLwgtt8-K0op2jKVA/viewform?usp=dialog"
              width="100%" height="800"
              frameBorder="0" marginHeight="0" marginWidth="0"
              title="Spanish Placement Test"
              style={{display:'block'}}
            >
              Cargando…
            </iframe>
          </div>

          <div style={{textAlign:'center', marginTop:'40px'}}>
            <div style={{display:'flex', gap:'16px', justifyContent:'center', flexWrap:'wrap'}}>
              <Link to="/Spanish" className="btn-glow">View Spanish Classes →</Link>
              <Link to="/contacto" className="btn-outline" style={{color:'var(--navy)', border:'1.5px solid var(--navy)'}}>Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PlacementTest;
